import { FormattedMessage } from "react-intl";

import { Button } from "ui/Button/Button";
import { Modal } from "ui/Modal/Modal";
import { BodyM, HeaderS } from "ui/Typography/Typography";

type DiscardDeliveryModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onClickPrimary: () => void;
  onClickSecondary: () => void;
};

export function DiscardDeliveryModal({
  isOpen,
  onClose,
  onClickPrimary,
  onClickSecondary,
}: DiscardDeliveryModalProps) {
  return (
    <Modal
      trapFocus={false}
      closeOnOverlayClick={false}
      isCentered
      isOpen={isOpen}
      onClose={onClose}
    >
      <Modal.Content maxW="295px" pt="s300" px="s200" pb="s200">
        <Modal.Body p="0">
          <HeaderS textAlign="center">
            <FormattedMessage id="components.activities.transport-equipment.discard-delivery-modal.title" />
          </HeaderS>
          <BodyM mt="s100" textAlign="center" color="grey.700">
            <FormattedMessage id="components.activities.transport-equipment.discard-delivery-modal.body" />
          </BodyM>
        </Modal.Body>
        <Modal.Footer p="0" mt="s200" flexDir="column" gap="s100">
          <Button onClick={onClickPrimary} variant="primary" size="lg" isFullWidth>
            <FormattedMessage id="components.activities.transport-equipment.discard-delivery-modal.cta.primary" />
          </Button>
          <Button onClick={onClickSecondary} variant="secondary" size="lg" isFullWidth>
            <FormattedMessage id="components.activities.transport-equipment.discard-delivery-modal.cta.secondary" />
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
}
